import React, { useEffect, useState } from 'react';
import {
  StyledHistoryWrapper,
  StyledParagraph,
  StyledTextLabel,
  StyledTextValueWrapper,
} from './StyledComponents';
import { FormattedDate } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectPartnerName } from 'modules/mac/duck/selectors';
import { State } from 'model/State';
import { Dimensions } from 'components/visuals';
import { MACPartnerDataType } from 'modules/mac/duck/models';

const AccountHistoryItem = ({ period, partnerIds }) => {
  const { partnerId } = period;
  const partnerData: MACPartnerDataType = useSelector((state) =>
    selectPartnerName(state as State, partnerId),
  );

  return (
    <>
      <StyledTextLabel width="auto" textalign="center">
        <FormattedDate
          value={new Date(period?.startDate)}
          day="2-digit"
          month="long"
          year="numeric"
        />
      </StyledTextLabel>
      <p>
        <StyledParagraph padding={`0 ${Dimensions.units(1.25)}px`}>
          {period.orderableItemDescription}
        </StyledParagraph>
      </p>
      {partnerIds.length > 0 && (
        <StyledTextValueWrapper>
          <p>{partnerData?.organisationDetails?.name}</p>
        </StyledTextValueWrapper>
      )}
    </>
  );
};

const AccountHistory = ({ accountHistory }) => {
  const [partnerIds, setPartnerIds] = useState<number[]>([]);

  useEffect(() => {
    accountHistory?.periods?.forEach((period) => {
      const { partnerId } = period;
      if (partnerId) setPartnerIds([...partnerIds, partnerId]);
    });
  }, [accountHistory]);

  return (
    <StyledHistoryWrapper data-cy="history-table" dispalyParterName={partnerIds.length > 0}>
      {accountHistory?.periods &&
        accountHistory.periods.map((period) => {
          return (
            <AccountHistoryItem key={period.periodId} period={period} partnerIds={partnerIds} />
          );
        })}
    </StyledHistoryWrapper>
  );
};

export default AccountHistory;
